import { defaultStackedBarChartProperties } from 'configs/charts'
import intl from 'localization/components'

export const companyTypeData = {
  endPoint: 'category',
  parameters: {
    list_id: 0,
    score_model: {},
    categories: [{ category: 'RISK_ASSESSMENT', function: 'COUNT' }],
    group_by: [{ category: 'COMPANY_TYPE_INTL' }, { category: 'RISK_ASSESSMENT' }],
  },
  chartProperties: {
    ...defaultStackedBarChartProperties,
    cartesianGrid: false,
    title: intl.observationalLists('risika-score-by-company-title'),
    height: 390,
    valueType: 'RISK',
  },
}

export type CompanyTypeData = typeof companyTypeData
